import React from 'react'

import { DISCLAIMER_SHORT, getLongDisclaimer } from './../../../constants/compliance'
import './ComplianceDisclaimer.component.scss'

/**
 * Discreet compliance disclaimer (UAD-3739).
 *
 * For STANDALONE placements only. Where the copy has to merge into an existing
 * consent paragraph so the two read as one disclaimer, import DISCLAIMER_SHORT
 * directly and render it inside that paragraph instead — nesting this
 * component there would break the inherited styling.
 *
 * @param variant   'short' (pre-submit / pre-booking) | 'long' (footers)
 * @param agentName only meaningful for 'long'; omit on generic pages
 * @param tone      'light' for dark backgrounds, 'dark' for light backgrounds
 * @param className caller hook for spacing — do not use it to override type
 */
const ComplianceDisclaimer = ({ variant = 'short', agentName = '', tone = 'dark', className = '' }) => {
  const text = variant === 'long' ? getLongDisclaimer(agentName) : DISCLAIMER_SHORT

  return <p className={`compliance-disclaimer compliance-disclaimer--${tone} ${className}`.trim()}>{text}</p>
}

export default ComplianceDisclaimer
